import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShieldUser: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconShieldUser"><Path fillRule="evenodd" clipRule="evenodd" d="M21 5.25391V13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13V5.25391L12 1.43555L21 5.25391ZM12 15C9.55769 15 7.40765 16.0722 6.15527 17.6973C7.52997 19.4056 9.63657 20.5 12 20.5C14.3627 20.5 16.4681 19.4057 17.8428 17.6982C16.5905 16.0732 14.4422 15 12 15ZM12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShieldUser;
